// Composer card with Reply / Internal note / Ask-for-phone tabs.
import type { ReactNode } from 'react';
import { useState } from 'react';
import { Icon } from '../../_shared/IconSprite.js';

export interface ComposerProps {
  draft: string;
  onDraftChange: (text: string) => void;
  onSend: () => void;
}

export function Composer({ draft, onDraftChange, onSend }: ComposerProps): ReactNode {
  const [tab, setTab] = useState<'reply' | 'note' | 'phone'>('reply');
  return (
    <section className="card composer">
      <div className="tabs">
        <button
          type="button"
          className={tab === 'reply' ? 'selected' : undefined}
          id="reply-tab"
          onClick={() => setTab('reply')}
          aria-pressed={tab === 'reply'}
        >
          Reply
        </button>
        <button
          type="button"
          className={tab === 'note' ? 'selected' : undefined}
          id="note-tab"
          onClick={() => setTab('note')}
          aria-pressed={tab === 'note'}
        >
          Internal note
        </button>
        <button
          type="button"
          id="ask-phone"
          onClick={() => setTab('phone')}
          aria-pressed={tab === 'phone'}
        >
          <Icon id="people" />
          Ask for phone number (optional)
        </button>
      </div>
      <textarea
        id="reply"
        aria-label={tab === 'note' ? 'Internal note' : 'Reply'}
        placeholder={tab === 'note' ? 'Internal note (not visible to the visitor)…' : 'Type your reply...'}
        value={draft}
        onChange={event => onDraftChange(event.target.value)}
      />
      <div id="draft-items" className="draft-items" />
      <div className="tools">
        <button className="link" id="attach" type="button">
          <Icon id="pin" />
          Attach
        </button>
        <button className="link" id="product" type="button">
          <Icon id="box" />
          Insert product
        </button>
        <span id="composer-hint">
          {tab === 'note' ? 'Visible only to you and the team.' : 'Send never finishes the conversation.'}
        </span>
        <button className="blue" id="send" type="button" onClick={onSend} disabled={!draft.trim()}>
          <Icon id="icon-send" />
          {tab === 'note' ? 'Save note' : 'Send reply'}
        </button>
      </div>
    </section>
  );
}
